import { createFileRoute } from '@tanstack/react-router'
import BillingEngineRun from '@/pages/BillingEngineRun/BillingEngineRun'
import { RequirePermission } from '@/components/ui/require-permission'

export const Route = createFileRoute(
  '/_authenticated/operation/billing-engine-run/'
)({
  component: () => (
    <RequirePermission permission='billing.run'>
      <BillingEngineRun />
    </RequirePermission>
  ),
})
